import { store } from '@/store/store';
import globals from '@/utils/globals';
import { computed, Ref, ref } from 'vue';
import { ComplexModal } from '@studyportals/modal';
import { OnMounted } from '@studyportals/vue-platform';
import { PopupStates } from '@/enums/popup-states';
import { Action } from '@studyportals/datalake-event-tracker';
import ITrackingObject from '@/interfaces/tracking-object.interface';
import { ModalManager, ModalState } from '@studyportals/modal';

export default class Popup implements OnMounted {
	private modal: Ref<ComplexModal | null> = ref(null);
	private hidden: Ref<boolean> = ref(false);
	private popupContent: Ref<HTMLElement | null> = ref(null);

	private modalManager = computed((): ModalManager | undefined => {
		return window['ModalManager'] as ModalManager;
	});

	constructor(private emit: (action: 'showOverview') => void) {
		globals.eventBus.on('openPopup', () => this.openPopup());
		globals.eventBus.on('closePopup', () => this.closePopup());
	}

	public mounted(): void {
		this.initiatePopup();
	}

	private initiatePopup(): void {
		if (this.modal.value !== null || !this.popupContent.value) {
			return;
		}

		this.modal.value = new ComplexModal(this.popupContent.value, {
			cssClassName: 'BestFitPopup',
			destroyOnClose: true,
			onClose: (): void => {
				this.hidden.value = true;
				store.mutations.setPopupState(PopupStates.CLOSED);
				this.trackPopupClosed();
			},
			onOpen: (): void => {
				store.mutations.setPopupState(PopupStates.OPENED);
				this.trackPopupOpened();
			},
		});
	}

	private closePopup(): void {
		if (!this.modal.value || !this.modalManager.value) {
			return;
		}

		this.hidden.value = true;
		const modalState = this.modal.value?.getState();

		if (modalState === ModalState.OPEN || modalState === ModalState.VISIBLE) {
			this.modalManager.value.close(this.modal.value);
		}
	}

	private openPopup(): void {
		if (!this.modal.value || !this.modalManager.value) {
			return;
		}

		this.hidden.value = false;
		const modalState = this.modal.value?.getState();

		if (modalState !== ModalState.OPEN && modalState !== ModalState.VISIBLE) {
			this.modalManager.value.open(this.modal.value);
			this.emit('showOverview');
		}
	}

	private trackPopupOpened(): void {
		const trackingParams: ITrackingObject = {
			action: Action.POPUP_OPEN,
		};
		globals.bestFitTracking.snowPlow(trackingParams);
	}

	private trackPopupClosed(): void {
		const trackingParams: ITrackingObject = {
			action: Action.POPUP_CLOSE,
		};
		globals.bestFitTracking.snowPlow(trackingParams);
	}
}
